const ScoreList = [
    { min: 0, max: 25, tripTypeIndex: 0, score: -20 },
    { min: 0, max: 25, tripTypeIndex: 1, score: -10 },
    { min: 0, max: 25, tripTypeIndex: 2, score: 5 },
    { min: 0, max: 25, tripTypeIndex: 3, score: -10 },
    { min: 0, max: 25, tripTypeIndex: 4, score: -10 },
    { min: 0, max: 25, tripTypeIndex: 5, score: 1 },
    { min: 0, max: 25, tripTypeIndex: 6, score: 10 },
    { min: 0, max: 25, tripTypeIndex: 7, score: -10 },
    { min: 0, max: 25, tripTypeIndex: 8, score: -10 },


    { min: 25, max: 45, tripTypeIndex: 0, score: -10 },
    { min: 25, max: 45, tripTypeIndex: 1, score: 1 },
    { min: 25, max: 45, tripTypeIndex: 2, score: 10 },
    { min: 25, max: 45, tripTypeIndex: 3, score: -5 },
    { min: 25, max: 45, tripTypeIndex: 4, score: -10 },
    { min: 25, max: 45, tripTypeIndex: 5, score: -5 },
    { min: 25, max: 45, tripTypeIndex: 6, score: 15 },
    { min: 25, max: 45, tripTypeIndex: 7, score: 1 },
    { min: 25, max: 45, tripTypeIndex: 8, score: 1 },


    { min: 45, max: 55, tripTypeIndex: 0, score: 5 },
    { min: 45, max: 55, tripTypeIndex: 1, score: 5 },
    { min: 45, max: 55, tripTypeIndex: 2, score: 15 },
    { min: 45, max: 55, tripTypeIndex: 3, score: 0 },
    { min: 45, max: 55, tripTypeIndex: 4, score: 0 },
    { min: 45, max: 55, tripTypeIndex: 5, score: 10 },
    { min: 45, max: 55, tripTypeIndex: 6, score: 20 },
    { min: 45, max: 55, tripTypeIndex: 7, score: 10 },
    { min: 45, max: 55, tripTypeIndex: 8, score: 5 },


    { min: 55, max: 200, tripTypeIndex: 0, score: 15 },
    { min: 55, max: 200, tripTypeIndex: 1, score: 15 },
    { min: 55, max: 200, tripTypeIndex: 2, score: 20 },
    { min: 55, max: 200, tripTypeIndex: 3, score: 0 },
    { min: 55, max: 200, tripTypeIndex: 4, score: 0 },
    { min: 55, max: 200, tripTypeIndex: 5, score: 15 },
    { min: 55, max: 200, tripTypeIndex: 6, score: 30 },
    { min: 55, max: 200, tripTypeIndex: 7, score: 15 },
    { min: 55, max: 200, tripTypeIndex: 8, score: 10 }
];

export default ScoreList;
